import { useCallback, useEffect, useState } from 'react'
import { twinFetchPostJSON } from '../../../../utils/globals/data'
import { getISOCurrencyMain } from '../../../../utils/reducers/getters'
import { roundNumberByParams, preciseDecimalSum } from '@teinor/erp/prices'
import { TwinDictionary } from '../../../../utils/globals/dictionary'
import { getCurrencySymbol } from '../../../../utils/globals/price'
import TwinTrans from '../../../TwinTrans'
import { displayFormatedNumber } from '../../../../utils/globals/numbers'
import useTwinTranslation from '../../../../utils/hooks/useTwinTranslation'
import { sellInvoiceStatusInversed } from '@teinor/erp/types/company/order/sell/sellInvoice'
import './sellinvoicestatusprogressbar.sass'

interface DSBSellInvoiceStatusProgressBarProps extends DSBSellInvoiceStatusProgressBarLogicProps {
    title?: string
}
const DSBSellInvoiceStatusProgressBar = ({ title, end_date, start_date }: DSBSellInvoiceStatusProgressBarProps) => {
    const mainCurrency = getISOCurrencyMain()
    const currencySymbol = getCurrencySymbol(mainCurrency)
    const { sellInvoice } = useDSBSellInvoiceStatusProgressBarLogic({ end_date, start_date })
    const renderHeader: JSX.Element[] = []
    const renderThis: JSX.Element[] = []
    for (const key in sellInvoice) {
        const item = sellInvoice[key]
        renderHeader.push(
            <div className='sell_invoice_progress_bar_header_box' key={key}>
                <div className='flex gap-10 items-center sell_invoice_progress_bar_header_inner_legend'>
                    <div className={'sell_invoice_progress_bar_header_inner_' + key}></div>
                    <div className={'sell_invoice_progress_bar_header_inner_status_name'}>{`${item.name}  (${item.totalStatus})`}</div>
                </div>
                <div className='sell_invoice_progress_bar_header_inner_amount'>{displayFormatedNumber(item.totalImport) + ' ' + currencySymbol}</div>
            </div>
        )
        renderThis.push(<div className={'sell_invoice_progress_bar_' + key} key={key} style={{ width:  item.totalStatusPer + '%'}}></div>)
    }
    if (renderHeader.length === 0) {
        renderHeader.push(<div key={'noData'}><TwinTrans transKey={'noData'} >No hay datos</TwinTrans></div>)
    }
    return (
        <div className='flex flex-col gap-20 flex-auto h-1'>
            <h3>{title}</h3>
            <div className='flex gap-x-30'>
                {renderHeader}
            </div>
            <div className='sell_invoice_progress_bar'>
                {renderThis}
            </div>
        </div>
    )
}

interface DSBSellInvoiceStatusProgressBarLogicProps {
    start_date: Date
    end_date: Date
}

const useDSBSellInvoiceStatusProgressBarLogic = ({ end_date, start_date }: DSBSellInvoiceStatusProgressBarLogicProps) => {
    const [sellInvoice, setSellInvoice] = useState<TwinDictionary>({})
    const {t} = useTwinTranslation()
    const myStatus = JSON.stringify({
        [sellInvoiceStatusInversed['creating']]: t('draft', 'Borrador'),
        [sellInvoiceStatusInversed['accepted']]: t('accepted', 'Aceptado'),
        [sellInvoiceStatusInversed['refunded']]: t('refunded', 'Devuelto'),
    })

    const getData = useCallback(async () => {
        const myStatusParsed = JSON.parse(myStatus)
        const result = await twinFetchPostJSON('/api/app/order/sell/sellInvoice/getAllSellInvoicesForStats', {
            attributes: ['total_without_vat', 'status'],
            where: { 'SellInvoice.createdAt': { '$betweenN': [start_date, end_date] }, is_last: true }
        })
        const statusDict: TwinDictionary = {}
        let myTotal = 0
        if (result) {
            for (const element of result) {
                const myStatus = element.status
                myTotal += 1
                if (!statusDict[myStatus]) {
                    statusDict[myStatus] = {
                        totalStatus: 0,
                        totalImport: 0,
                        name: myStatusParsed[parseInt(myStatus)]
                    }
                }
                statusDict[myStatus].totalStatus += 1
                statusDict[myStatus].totalImport = parseFloat(roundNumberByParams(preciseDecimalSum(statusDict[myStatus].totalImport, parseFloat(element.total_without_vat))).toFixed(2))
            }

            for (const key in statusDict) {
                const element = statusDict[key]
                statusDict[key] = {
                    totalStatusPer: (element.totalStatus / myTotal) * 100,
                    totalImport: element.totalImport,
                    totalStatus: element.totalStatus,
                    name: element.name
                }
            }

            setSellInvoice(statusDict)
        }
    }, [setSellInvoice, end_date, start_date, myStatus])

    useEffect(() => {
        getData()
    }, [getData])

    return { sellInvoice }
}


export default DSBSellInvoiceStatusProgressBar